module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "item-rate-breakdown-window"
    }
  }, [_c('section', {
    staticClass: "box-shadow",
    attrs: {
      "id": "rate-breakdown-box"
    }
  }, [_c('header', [_c('i', {
    staticClass: "ion ion-close-round sm",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('blockquote', [_vm._v("\n        " + _vm._s(_vm.headerText) + "\n      ")])]), _vm._v(" "), _c('main', {
    attrs: {
      "id": "totals-table-container"
    }
  }, [_c('h4', [_vm._v("Current selection")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("Value")]), _vm._v(" "), (_vm.workBenchComparison) ? _c('th', [_vm._v("\n              Workbench option " + _vm._s(_vm.workBenchComparison) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Provider Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.serviceProviderName))]), _vm._v(" "), (_vm.workBenchComparison) ? _c('td', [_vm._v(_vm._s(_vm.comparison.serviceProviderName))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Provider Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.serviceProvider))]), _vm._v(" "), (_vm.workBenchComparison) ? _c('td', [_vm._v(_vm._s(_vm.comparison.serviceProvider))]) : _vm._e()]), _vm._v(" "), (_vm.item.serviceNote) ? _c('tr', [_c('td', [_vm._v("Service Note")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.serviceNote))]), _vm._v(" "), (_vm.workBenchComparison) ? _c('td', [_vm._v(_vm._s(_vm.comparison.serviceNote))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Quote Currency Rate")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.response.responseCurrency) + " " + _vm._s(_vm.numberFormat(_vm.item.baseRate)))]), _vm._v(" "), (_vm.workBenchComparison) ? _c('td', [_vm._v(_vm._s(_vm.comparison.responseCurrency) + " " + _vm._s(_vm.numberFormat(_vm.comparison.baseRate)))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tariff Currency Rate")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.currency) + " " + _vm._s(_vm.numberFormat(_vm.item.rate)))]), _vm._v(" "), (_vm.workBenchComparison) ? _c('td', [_vm._v(" " + _vm._s(_vm.comparison.currency) + " " + _vm._s(_vm.numberFormat(_vm.comparison.reportingCurrencyRate)))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Duration")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.duration) + " " + _vm._s(_vm.item.durationType))]), _vm._v(" "), (_vm.workBenchComparison) ? _c('td', [_vm._v(_vm._s(_vm.comparison.duration) + " " + _vm._s(_vm.comparison.durationType))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Quality")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.providerQuality || ''))]), _vm._v(" "), (_vm.workBenchComparison) ? _c('td', [_vm._v(_vm._s(_vm.comparison.providerQuality || ''))]) : _vm._e()]), _vm._v(" "), (_vm.item.distance) ? _c('tr', [_c('td', [_vm._v("Distance")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.distance || '') + " " + _vm._s(_vm.item.distanceType || ''))]), _vm._v(" "), (_vm.workBenchComparison) ? _c('td', [_vm._v(_vm._s(_vm.comparison.distance || '') + " " + _vm._s(_vm.comparison.distanceType || ''))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.item.details[0]), function(value, detail) {
    return _c('tr', [(detail === 'rateInCurrency') ? _c('td', [_vm._v("Calculated Tariff Rate (without Static Cost)")]) : (detail === 'staticCosts') ? _c('td', [_vm._v("Additions (Static Costs)")]) : (detail === 'ratePer') ? _c('td', [_vm._v("Tariff Line Rate (Rate Per)")]) : (detail === 'calculatedPer') ? _c('td', [_vm._v("Per")]) : _c('td', [_vm._v(_vm._s(_vm.deCamel(detail)))]), _vm._v(" "), (detail === 'staticCosts' && value) ? _c('td', _vm._l((value.split('; ')), function(line) {
      return _c('div', [_c('span', {
        class: {
          'red-highlight': line.includes('(Advice Only')
        }
      }, [_vm._v(_vm._s(line))])])
    }), 0) : (detail === 'rateInCurrency') ? _c('td', [_vm._v("\n              " + _vm._s(_vm.item.currency) + " " + _vm._s(_vm.getVal(value, detail)) + "\n            ")]) : (detail === 'ratePer') ? _c('td', [_vm._v("\n              " + _vm._s(_vm.item.currency) + " " + _vm._s(_vm.getVal(value, detail)) + "\n            ")]) : _c('td', [_vm._v(_vm._s(_vm.getVal(value, detail)))]), _vm._v(" "), (_vm.workBenchComparison) ? _c('td', [_vm._v("\n              " + _vm._s(_vm.comparison.details[0].hasOwnProperty(detail) ? _vm.getVal(_vm.comparison.details[0][detail], detail) : '') + "\n            ")]) : _vm._e()])
  })], 2)])]), _vm._v(" "), (_vm.workbenchRequested && _vm.workBenchOptions.length) ? _c('work-bench', {
    attrs: {
      "options": _vm.workBenchOptions,
      "currentSelection": _vm.item
    },
    on: {
      "choice-made": _vm.emitNewOption,
      "comparison": function (optionNumber) { return _vm.workBenchComparison = optionNumber; }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('footer', {
    staticClass: "clearfix pad-b5"
  }, [_c('div', {
    staticClass: "pull-right full-w-sm"
  }, [(_vm.isWorkbenchEnabled) ? _c('div', {
    staticClass: "btn btn-primary sq full-w-sm",
    on: {
      "click": _vm.sendWorkbenchRequest
    }
  }, [_vm._v("\n          Workbench "), _c('pulse-loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      display: 'inline'
    }),
    attrs: {
      "size": '3px'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn btn-info sq full-w-sm",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n          Back "), _c('i', {
    staticClass: "fa fa-backward"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b2c0b43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteRateItemBreakDown.vue
// module id = 2193
// module chunks = 1